var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrinder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.833,
    height: 44.758,
    viewBox: "0 0 59.833 44.758",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Disk_Cutter",
    "data-name": "Disk Cutter",
    transform: "translate(0 -3.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M59.589,28.649a19.048,19.048,0,0,0-19.3-15.732,18.625,18.625,0,0,0-15.358,9.375V15.71l6.383-6.383a3.74,3.74,0,0,0-5.286-5.286l-7.48,7.48a3.74,3.74,0,0,0-.9,1.4H8.726A8.726,8.726,0,0,0,0,21.643V36.6A1.247,1.247,0,0,0,1.247,37.85H23.686a16.082,16.082,0,0,0,2.244-.823,16.106,16.106,0,0,0,30.393,0l1.2.424A1.247,1.247,0,0,0,59.14,36.6a18.226,18.226,0,0,0,.449-7.953ZM19.946,24.137A1.247,1.247,0,0,1,18.7,25.383H6.233a1.247,1.247,0,0,1-1.247-1.247V21.643a3.74,3.74,0,0,1,3.74-3.74H18.7a1.247,1.247,0,0,1,1.247,1.247Zm28.822,18.7V39.52a1.247,1.247,0,0,0-1.222-1.272,1.272,1.272,0,0,0-1.272,1.222l-.125,4.737a13.563,13.563,0,0,1-2.992.848l1.5-3.017a1.247,1.247,0,1,0-2.219-1.122l-2.044,4.413a13.588,13.588,0,0,1-4.189-.9l2.792-1.845a1.247,1.247,0,0,0-1.371-2.069l-3.939,2.493a13.713,13.713,0,0,1-2.493-1.97l3.316-.5a1.261,1.261,0,0,0-.374-2.493l-4.687.7A13.638,13.638,0,0,1,28.2,36.1l9.624-3.241a1.247,1.247,0,0,0,.823-1.172V30.37a2.493,2.493,0,1,1,4.986,0v1.247a1.247,1.247,0,0,0,.823,1.172l5.859,2.094a1.222,1.222,0,0,0-1.072,1.72l1.895,4.388a13.712,13.712,0,0,1-2.369,1.845Zm4.064-4.288L51.51,35.506a1.247,1.247,0,0,0-.3-.424l2.768,1a13.638,13.638,0,0,1-1.147,2.593Z",
    transform: "translate(0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrinder);
export default __webpack_public_path__ + "static/media/grinder.91250a9403f5711e351fa5f38909be52.svg";
export { ForwardRef as ReactComponent };